import ContratoInterceptor from '../ContratoInterceptor'
import { Contrato } from '../../../types/Contratos'

const api = new ContratoInterceptor()

export default {
  activeContrato(contratoId: String) {
    return api.post(`/contratos/${contratoId}/ativar`, null)
  },

  createContrato(contrato: Contrato) {
    return api.post(`/contratos`, contrato)
  },

  getContrato(contratoId: String) {
    return api.get(`/contratos/${contratoId}`)
  },

  isContratoPlantao() {
    return api.get(`/users/current/tem-contrato-plantao`)
  },
  
  getGestorContratos(gestorId: String) {
    return api.get(`/contratos/gestores/${gestorId}`)
  },

  inactiveContrato(contratoId: String) {
    return api.post(`/contratos/${contratoId}/inativar`, null)
  },

  updateContrato(contratoId, contrato: Contrato) {
    return api.put(`/contratos/${contratoId}`, contrato)
  },
}
